(() => {
  const storageKey = 'lukzer:recently-viewed:v2';

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer, .cart_canvas, #cart_canvas, [data-cart-drawer]');
    if (drawer?.open) drawer.open();
    else document.querySelector('[data-toggle="canvas"][data-target="#cart_canvas"], .site-header__cart')?.click();
  };

  class PremiumRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.manual === 'true' || this.querySelector('[data-related-grid]')) return;
      fetch(this.dataset.url)
        .then((response) => response.ok ? response.text() : Promise.reject(new Error('Recommendations unavailable')))
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const replacement = html.querySelector(`#${CSS.escape(this.id)}`);
          if (replacement?.querySelector('[data-related-grid]')) this.innerHTML = replacement.innerHTML;
        })
        .catch(() => this.hidden = true);
    }
  }

  class RecentlyViewedPremium extends HTMLElement {
    connectedCallback() {
      const currentCard = this.querySelector('[data-current-product-card]')?.innerHTML.trim();
      const currentId = String(this.dataset.currentId);
      const relatedIds = new Set([...document.querySelectorAll('[data-related-product-id]')].map((node) => node.dataset.relatedProductId));
      let items = [];

      try {
        items = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(items)) items = [];
      } catch (_) {
        items = [];
      }

      const visible = items
        .filter((item) => String(item.id) !== currentId && !relatedIds.has(String(item.id)) && item.html)
        .slice(0, Number(this.dataset.limit) || 6);
      const grid = this.querySelector('[data-recent-grid]');
      if (grid) grid.innerHTML = visible.map((item) => item.html).join('');

      if (!visible.length) this.hidden = true;
      if (currentCard) {
        const current = { id: currentId, handle: this.dataset.currentHandle, html: currentCard, viewedAt: Date.now() };
        items = [current, ...items.filter((item) => String(item.id) !== currentId)].slice(0, 12);
        try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch (_) {}
      }
    }
  }

  if (!customElements.get('premium-product-recommendations')) {
    customElements.define('premium-product-recommendations', PremiumRecommendations);
  }
  if (!customElements.get('recently-viewed-premium')) {
    customElements.define('recently-viewed-premium', RecentlyViewedPremium);
  }

  const initProductGallery = (root = document) => {
    root.querySelectorAll('.product-gallery').forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';

      gallery.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-thumbnail], .product-thumbnail');
        if (!thumbnail || !gallery.contains(thumbnail)) return;

        event.preventDefault();
        event.stopPropagation();

        const productRoot = gallery.closest('lukzer-product-detail');
        if (productRoot && typeof productRoot.selectMedia === 'function') {
          productRoot.selectMedia(thumbnail.dataset.mediaId, true, thumbnail);
          return;
        }

        const mainImage = gallery.querySelector('.product-main-image img, .lkz-pdp__main-image');
        if (!mainImage) return;

        const fullImage = thumbnail.dataset.fullImage;
        const srcset = thumbnail.dataset.srcset;
        const alt = thumbnail.dataset.alt;
        const zoom = thumbnail.dataset.zoom || fullImage;

        gallery.querySelectorAll('[data-thumbnail], .product-thumbnail').forEach((item) => {
          const active = item === thumbnail;
          item.classList.toggle('is-active', active);
          item.classList.toggle('active', active);
          item.setAttribute('aria-current', String(active));
        });

        if (fullImage) {
          mainImage.setAttribute('src', fullImage);
          mainImage.setAttribute('data-src', fullImage);
        }
        if (srcset) {
          mainImage.setAttribute('srcset', srcset);
          mainImage.setAttribute('data-srcset', srcset);
        }
        if (alt) mainImage.setAttribute('alt', alt);

        const zoomTarget = gallery.querySelector('[data-open-lightbox], [data-zoom], .product-main-image a');
        if (zoomTarget && zoom) {
          zoomTarget.setAttribute('data-zoom', zoom);
          zoomTarget.setAttribute('data-pswp-src', zoom);
          if (zoomTarget.matches('a')) zoomTarget.setAttribute('href', zoom);
        }
      });
    });
  };

  const initPremiumProductSections = (root = document) => {
    initProductGallery(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPremiumProductSections());
  } else {
    initPremiumProductSections();
  }
  document.addEventListener('shopify:section:load', (event) => initPremiumProductSections(event.target));

  document.addEventListener('click', (event) => {
    const navLink = event.target.closest('.lkz-product-nav a[href^="#"]');
    if (navLink) {
      const target = document.querySelector(navLink.getAttribute('href'));
      if (!target) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-premium-card-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-card-message]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (message) message.textContent = '';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this product.');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: payload }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: payload }));
      openCartDrawer();
    } catch (error) {
      if (message) message.textContent = error.message;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  const nav = document.querySelector('.lkz-product-nav');
  if (nav && 'IntersectionObserver' in window) {
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    links.forEach((link) => {
      if (!document.querySelector(link.getAttribute('href'))) link.hidden = true;
    });
    const sections = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`));
    }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, .2, .5] });
    sections.forEach((section) => observer.observe(section));
  }

  document.querySelectorAll('[data-thumbnails]').forEach((track) => {
    if (track.dataset.lkzScrollerBound === 'true') return;
    let startX = 0;
    let startScroll = 0;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (!track.hasPointerCapture(event.pointerId)) return;
      track.scrollLeft = startScroll - (event.clientX - startX);
    });
  });

  const initPremiumReviews = () => {
    const section = document.querySelector('[data-lkz-review-section]');
    const canonical = section?.querySelector('[data-lkz-review-canonical]');
    if (!section || !canonical) return;
    if (section.dataset.lkzReviewsInitialized === 'true') return;
    section.dataset.lkzReviewsInitialized = 'true';

    const configuredCount = Number.parseInt(section.dataset.reviewCount || '0', 10);
    const reviewCount = Number.isFinite(configuredCount) ? configuredCount : 0;
    section.classList.toggle('is-zero-reviews', reviewCount === 0);
    section.classList.toggle('has-reviews', reviewCount > 0);
    section.classList.add('is-review-loading');

    const fullReviewSelectors = [
      '#AirReviews-BlockWrapper',
      '.AirReviews-BlockWrapper',
      '[data-air-reviews-block]'
    ].join(',');

    const isFullReviewWidget = (node) => {
      if (!(node instanceof HTMLElement)) return false;
      if (node.matches('.AirReviews-Widget--Stars, [class*="Widget--Stars"]')) return false;
      const text = node.textContent?.toLowerCase() || '';
      return text.includes('review') && (
        text.includes('click to review') ||
        text.includes('write a review') ||
        text.includes('no reviews yet') ||
        node.querySelector('form, textarea, [class*="progress"], [class*="rating"]')
      );
    };

    const removeDuplicateWidgets = () => {
      document.querySelectorAll(fullReviewSelectors).forEach((widget) => {
        if (!canonical.contains(widget) && isFullReviewWidget(widget)) widget.remove();
      });

      const canonicalWidgets = [...canonical.querySelectorAll(fullReviewSelectors)].filter(isFullReviewWidget);
      canonicalWidgets.slice(1).forEach((widget) => widget.remove());
    };

    const removeStaleLoaders = () => {
      canonical.querySelectorAll('*').forEach((element) => {
        if (element.closest('form')) return;
        const styles = window.getComputedStyle(element);
        const bounds = element.getBoundingClientRect();
        if (
          (
            styles.animationName !== 'none' ||
            /spinner|loader|loading/i.test(`${element.className || ''} ${element.id || ''}`)
          ) &&
          bounds.width > 8 &&
          bounds.width < 90 &&
          bounds.height > 8 &&
          bounds.height < 90 &&
          !element.textContent.trim()
        ) {
          element.classList.add('lkz-review-stale-loader');
        }
      });
    };

    const enhanceWidget = () => {
      removeDuplicateWidgets();

      canonical.querySelectorAll('button, a, span, p, div').forEach((element) => {
        if (element.children.length) return;
        const label = element.textContent.trim().toLowerCase();
        if (label === 'click to review') {
          element.textContent = element.matches('button, a') ? 'Write a Review' : 'Share Your Experience';
          element.classList.add('lkz-review-cta-label');
        }
        if (label === 'no reviews yet, lead the way and share your thoughts') {
          element.textContent = 'No reviews yet. Be the first to share your experience with this product.';
          element.classList.add('lkz-review-empty-message');
        }
      });

      const starSelector = 'svg, [class*="star" i], [aria-label*="star" i]';
      const findContainer = (start, predicate) => {
        let node = start;
        while (node && node !== canonical) {
          if (predicate(node)) return node;
          node = node.parentElement;
        }
        return null;
      };
      const textOf = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      [...canonical.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]')].forEach((heading) => {
        if (textOf(heading) === 'reviews') heading.classList.add('lkz-review-app-heading');
      });
      const looseAppHeading = [...canonical.querySelectorAll('div, span, p')].find((element) => (
        !element.children.length &&
        textOf(element) === 'reviews' &&
        element.getBoundingClientRect().top < canonical.getBoundingClientRect().top + 160
      ));
      looseAppHeading?.classList.add('lkz-review-app-heading');

      const shareLabel = [...canonical.querySelectorAll('*')].find((element) => {
        const text = textOf(element);
        return !element.children.length && (text === 'share your experience' || text === 'click to review');
      });
      const shareCard = findContainer(shareLabel, (node) => (
        node.querySelectorAll(starSelector).length >= 5 &&
        textOf(node).length < 500
      ));
      if (shareCard) shareCard.classList.add('lkz-review-summary-card', 'lkz-review-share-card');

      const breakdownCard = [...canonical.querySelectorAll('div, section, article')]
        .filter((node) => {
          const text = textOf(node);
          const progressRows = node.querySelectorAll('[class*="progress" i], [role="progressbar"]').length;
          return progressRows >= 5 && /\b5\b/.test(text) && /\b1\b/.test(text) && text.length < 700;
        })
        .sort((a, b) => textOf(a).length - textOf(b).length)[0];
      if (breakdownCard) {
        breakdownCard.classList.add('lkz-review-summary-card', 'lkz-review-breakdown-card');
      }

      const countLabel = [...canonical.querySelectorAll('*')].find((element) => (
        !element.children.length && /^\d+\s+reviews?$/.test(textOf(element))
      ));
      const ratingCard = findContainer(countLabel, (node) => (
        node !== shareCard &&
        node !== breakdownCard &&
        node.querySelectorAll(starSelector).length >= 5 &&
        textOf(node).length < 260
      ));
      if (ratingCard) ratingCard.classList.add('lkz-review-summary-card', 'lkz-review-rating-card');

      if (reviewCount === 0) {
        [ratingCard, breakdownCard].filter(Boolean).forEach((card) => {
          card.classList.add('lkz-review-zero-stat');
          let branch = card;
          while (
            branch.parentElement &&
            branch.parentElement !== canonical &&
            branch.parentElement.children.length === 1
          ) {
            branch = branch.parentElement;
          }
          branch.classList.add('lkz-review-zero-stat-branch');
        });
      }

      const summaryCards = [ratingCard, breakdownCard, shareCard].filter(Boolean);
      if (summaryCards.length >= 2) {
        let summaryRow = summaryCards[0].parentElement;
        while (summaryRow && summaryRow !== canonical && !summaryCards.every((card) => summaryRow.contains(card))) {
          summaryRow = summaryRow.parentElement;
        }
        if (summaryRow && summaryRow !== canonical) {
          summaryRow.classList.add('lkz-review-summary-grid');

          if (reviewCount === 0 && shareCard) {
            summaryRow.classList.add('lkz-review-empty-summary');

            [...summaryRow.children].forEach((branch) => {
              if (branch === shareCard || branch.contains(shareCard)) {
                branch.classList.add('lkz-review-invitation-branch');
              } else {
                branch.classList.add('lkz-review-hidden-stat-branch');
              }
            });

            let invitationShell = shareCard.parentElement;
            while (invitationShell && invitationShell !== summaryRow) {
              invitationShell.classList.add('lkz-review-invitation-shell');
              invitationShell = invitationShell.parentElement;
            }
          }
        }
      }

      const emptyMessage = canonical.querySelector('.lkz-review-empty-message');
      const emptyCard = findContainer(emptyMessage, (node) => {
        const styles = window.getComputedStyle(node);
        return node !== emptyMessage && (
          parseFloat(styles.borderTopWidth) > 0 ||
          styles.boxShadow !== 'none' ||
          node.clientHeight > 70
        );
      });
      if (emptyCard) emptyCard.classList.add('lkz-review-empty-card');

      if (shareCard) {
        const starElements = [...shareCard.querySelectorAll(starSelector)]
          .filter((star, index, stars) => !stars.some((other, otherIndex) => otherIndex !== index && star.contains(other)));
        const starControls = [];
        starElements.forEach((star) => {
          const control = star.closest('button, label, [role="radio"], [data-rating], a') || star;
          if (!starControls.includes(control)) starControls.push(control);
        });

        if (starControls.length >= 5) {
          const group = starControls[0].parentElement;
          group?.classList.add('lkz-review-star-group');
          starControls.slice(0, 5).forEach((control, index) => {
            control.classList.add('lkz-review-star-control');
            control.style.setProperty('--lkz-star-index', index);
            if (!control.matches('button, a, input, label, [role="radio"], [role="button"]')) {
              control.setAttribute('role', 'button');
              control.setAttribute('tabindex', '0');
              control.setAttribute('aria-label', `Rate ${index + 1} star${index === 0 ? '' : 's'}`);
              control.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                control.click();
              });
            }
            if (control.dataset.lkzStarEnhanced === 'true') return;
            control.dataset.lkzStarEnhanced = 'true';
            const preview = () => {
              starControls.slice(0, 5).forEach((item, itemIndex) => {
                item.classList.toggle('is-lkz-preview', itemIndex <= index);
              });
            };
            control.addEventListener('pointerenter', preview);
            control.addEventListener('focus', preview);
          });
          if (group && group.dataset.lkzStarEnhanced !== 'true') {
            group.dataset.lkzStarEnhanced = 'true';
            const clearPreview = () => starControls.forEach((item) => item.classList.remove('is-lkz-preview'));
            group.addEventListener('pointerleave', clearPreview);
            group.addEventListener('focusout', (event) => {
              if (!group.contains(event.relatedTarget)) clearPreview();
            });
          }

          let reviewButton = shareCard.querySelector('.lkz-review-cta');
          if (!reviewButton) {
            reviewButton = document.createElement('button');
            reviewButton.type = 'button';
            reviewButton.className = 'lkz-review-cta';
            reviewButton.textContent = 'Write a Review';
            reviewButton.setAttribute('aria-label', 'Write a review for this product');
            reviewButton.addEventListener('click', () => {
              const nativeTrigger = [...canonical.querySelectorAll('button, a, [role="button"]')].find((control) => {
                if (control === reviewButton) return false;
                const label = `${textOf(control)} ${control.getAttribute('aria-label') || ''}`.toLowerCase();
                return label.includes('write a review') || label.includes('click to review') || label.includes('add review');
              });
              if (nativeTrigger) {
                nativeTrigger.click();
              } else {
                starControls[0].click();
              }
            });
            group?.insertAdjacentElement('afterend', reviewButton);
          }
        }
      }

      canonical.querySelectorAll('button, a, [role="button"]').forEach((control) => {
        const label = `${control.textContent} ${control.getAttribute('aria-label') || ''}`.toLowerCase();
        if (
          label.includes('write a review') ||
          label.includes('click to review') ||
          label.includes('share your experience') ||
          label.includes('add review')
        ) {
          control.classList.add('lkz-review-action');
        }
      });

      canonical.querySelectorAll('[class*="progress"], [class*="Progress"]').forEach((bar) => {
        if (!bar.classList.contains('lkz-review-progress')) bar.classList.add('lkz-review-progress');
      });

      const appReady = reviewCount === 0
        ? Boolean(shareCard)
        : Boolean(ratingCard && breakdownCard && shareCard);
      if (appReady) {
        removeStaleLoaders();
        section.classList.remove('is-review-loading', 'is-review-failed');
        section.classList.add('is-review-ready');
      }
    };

    let scheduled = false;
    const scheduleEnhancement = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        enhanceWidget();
      });
    };

    enhanceWidget();
    const observer = new MutationObserver(scheduleEnhancement);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      removeStaleLoaders();
      section.classList.remove('is-review-loading');
      if (!section.classList.contains('is-review-ready')) section.classList.add('is-review-failed');
    }, 8000);
  };

  initPremiumReviews();
  document.addEventListener('shopify:section:load', initPremiumReviews);
})();
